export const LibraryTranslations = {
  libraryTranslations: {
    recentStories: 'Historias recientes',
    moreOn: 'Más sobre el',
  }
}